import type { Edge, Node } from "@xyflow/react";

export enum DocumentViewMode {
    TABLE = "table",
    EXPLODE = "explode",
}

export enum NodeKind {
    BUCKET = "bucket",
}

export enum NodeRole {
    ROOT = "root",
    GROUP = "group",
}

export interface BucketSelection {
    field: string;
    value: string;
}

export interface TypeBucket {
    value: string;
    count: number;
}

export interface DocumentTypeConfig {
    field: string;
    label: string;
    types: TypeBucket[];
}

export type ExplodeNodeData = {
    label: string;
    role: NodeRole;
    selection: BucketSelection[];
    count?: number;
};

export interface ExplodeFlow {
    nodes: Node<ExplodeNodeData>[];
    edges: Edge[];
}

export interface BuildTypeGraphParams {
    types: TypeBucket[];
    field: string;
    rootLabel: string;
}

export interface ResolveDocumentTypeDataParams {
    index: string;
}

export interface UseExpandGraphParams {
    index: string;
    rootLabel: string;
}

export interface ExpandGraphProps {
    index: string;
    rootLabel: string;
    onOpen: (selection: BucketSelection[]) => void;
}

export interface DocumentViewsProps {
    index: string;
    rootLabel: string;
    onFilteredCountChange?: (count: number) => void;
}
